import React, { useState, useEffect, useMemo } from "react";
import "./Grid.scss";
import MenuTab from "../../../Home/WorksTab/MenuTab";
import ContentDialog from "./ContentDialog/ContentDialog";
import { GetThumbnail } from "./GetThumbnail/GetThumbnail";
import classNames from "classnames";

import Book from "src/_asset/images/svg/book.svg";
import useDidMountEffect from "src/Util/useDidMountEffect";
import { fetchWorksContents } from "src/services/worksService";

const TYPE_BY_CATEGORY = {
    1: "advertisement",
    2: "music_video",
    3: "motion",
    4: "title",
    5: "artwork",
    6: null, // Etc
};

const Grid = ({ onLoad }) => {
    const [categoryCount, setCategoryCount] = useState(0);
    const [category, setCategory] = useState(0);
    const [isShow, setShow] = useState(false);
    const [selectedItem, setItem] = useState(0);
    const [videos, setVideos] = useState([]);
    const [isNoData, setNoData] = useState(false);

    const [isAllVideo, setIsAllVideo] = useState(false);

    const filteredVideos = useMemo(() => {
        if (!videos || !videos.length) return [];

        if (category === 0) {
            // All
            return videos;
        }

        const type = TYPE_BY_CATEGORY[category];

        if (type === null) {
            // Etc: items whose type is not one of the known types
            const knownTypes = Object.values(TYPE_BY_CATEGORY).filter((t) => t);
            return videos.filter((item) => !knownTypes.includes(item.type));
        }

        return videos.filter((item) => item.type === type);
    }, [videos, category]);

    const countWorks = filteredVideos.length;

    const fetchAndStoreWorks = async (currentCategory) => {
        try {
            setIsAllVideo(false);
            setNoData(false);

            let type;
            if (currentCategory && currentCategory !== 0) {
                type = TYPE_BY_CATEGORY[currentCategory];
            }

            const data = await fetchWorksContents({ type });
            if (!data || !data.length) {
                setNoData(true);
            } else {
                setVideos(data);
            }
            setIsAllVideo(true);
        } catch (error) {
            setNoData(true);
            setIsAllVideo(true);
        }
    };

    useEffect(() => {
        fetchAndStoreWorks(category);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category]);

    useDidMountEffect(() => {
        onLoad();
    }, [isAllVideo]);

    // ** End of -> Get all video from channel

    const [height, setHeight] = useState();

    useEffect(() => {
        const elmnt = document.getElementById("Showreel2021");
        if (elmnt) {
            setHeight(elmnt.offsetHeight);
        }
    }, []);

    useEffect(() => {
        if (isAllVideo && filteredVideos.length === 0) {
            setNoData(true);
        } else if (filteredVideos.length > 0) {
            setNoData(false);
        }
    }, [filteredVideos, isAllVideo]);

    const checkNoData = countWorks === 0 && isNoData;
    return (
        <div className="ex-main-grid">
            <div className="experience__grid">
                <MenuTab
                    category={category}
                    setCategory={setCategory}
                    setCategoryCount={setCategoryCount}
                    countWorks={countWorks}
                />
                <div className={classNames("experience__list", { "no-data": checkNoData })}>
                    {filteredVideos.length > 0 &&
                        filteredVideos.map((e, i) => {
                            const thumbnail =
                                e.video_url?.thumb_url ||
                                e.thumbnail_large ||
                                e.thumbnailUrl ||
                                e.thumbnail ||
                                e.coverImage ||
                                e.imageUrl;
                            const videoUrl =
                                e.video_url?.url ||
                                e.videoNew ||
                                e.videoUrl ||
                                e.mediaUrl ||
                                e.url;

                            return (
                                <div key={e.id || i} className="experience__item bx active visible">
                                    <a
                                        className="item__link"
                                        href="#"
                                        onClick={(event) => {
                                            event.preventDefault();
                                            setItem(e);
                                            setShow(true);
                                        }}
                                    >
                                        <div className="item__frame">
                                            <div className="item__dimd">
                                                {thumbnail ? (
                                                    <img src={thumbnail} alt={e.title || "thumbnail"} />
                                                ) : (
                                                    videoUrl && (
                                                        <GetThumbnail
                                                            style={{ height: height }}
                                                            id={e.id}
                                                            url={videoUrl}
                                                        />
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            );
                        })}
                    {checkNoData && (
                        <div className="no-data">
                            <img src={Book} alt="" />
                            <span className="top">No data</span>
                            <span className="sub">No data, please try again later</span>
                        </div>
                    )}
                </div>
            </div>

            {isShow && <ContentDialog setOpenPopup={() => setShow(false)} data={selectedItem} />}
        </div>
    );
};

export default Grid;
